import { ReactNode } from 'react';
import {
  ProductAngeplusFillMediumIcon,
  ProductAngeplusOutlineMediumIcon,
  MenuBarBase,
  MenuLinkPrimary,
  HomeOutlineMediumIcon,
  HomeFillMediumIcon,
  PetsOutlineMediumIcon,
  ProductPetFillMediumIcon,
} from '@angeplus/prever-component-lib';
import { routes } from 'modules/routes';
import { useV2CurrentAccount } from '@ferreri/minato-auth-react';
import { SETTINGS } from 'config/settings';

export type TelevetMenuProps = {
  children?: ReactNode;
};

export const TelevetMenu = (props: TelevetMenuProps) => {
  const { data: account } = useV2CurrentAccount();
  const href = `${SETTINGS.public.basePath}${
    routes.accounts(account?.id as string).televeterinary
  }`;

  return (
    <MenuBarBase subMenu={props.children}>
      <MenuLinkPrimary
        label={'Angeplus'}
        href={routes.pathHub}
        icon={<ProductAngeplusOutlineMediumIcon />}
        activeIcon={<ProductAngeplusFillMediumIcon />}
      />
      <MenuLinkPrimary
        label={'Para seu Pet'}
        href={`${SETTINGS.public.basePath}${routes.home}`}
        shouldExactlyMatch
        icon={<HomeOutlineMediumIcon />}
        activeIcon={<HomeFillMediumIcon />}
      />
      <MenuLinkPrimary
        label={'Teleconsulta'}
        href={href}
        icon={<PetsOutlineMediumIcon />}
        activeIcon={<ProductPetFillMediumIcon />}
      />
    </MenuBarBase>
  );
};
